var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_434_5851",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.888672,
    y: 0.675293,
    width: 20,
    height: 20,
    fill: "#676F83"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_434_5851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.889 10.6751C11.3473 10.6751 11.7397 10.5119 12.066 10.1855C12.3924 9.85916 12.5556 9.4668 12.5556 9.00846C12.5556 8.55013 12.3924 8.15777 12.066 7.83138C11.7397 7.50499 11.3473 7.3418 10.889 7.3418C10.4306 7.3418 10.0383 7.50499 9.71187 7.83138C9.38549 8.15777 9.22229 8.55013 9.22229 9.00846C9.22229 9.4668 9.38549 9.85916 9.71187 10.1855C10.0383 10.5119 10.4306 10.6751 10.889 10.6751ZM10.889 16.8001C12.5834 15.2446 13.8403 13.8314 14.6598 12.5605C15.4792 11.2897 15.889 10.1612 15.889 9.17513C15.889 7.66124 15.4063 6.42166 14.441 5.45638C13.4758 4.4911 12.2917 4.00846 10.889 4.00846C9.48618 4.00846 8.30215 4.4911 7.33687 5.45638C6.3716 6.42166 5.88896 7.66124 5.88896 9.17513C5.88896 10.1612 6.29868 11.2897 7.11812 12.5605C7.93757 13.8314 9.19451 15.2446 10.889 16.8001ZM10.889 19.0085C8.65285 17.1057 6.98271 15.3383 5.87854 13.7064C4.77437 12.0744 4.22229 10.564 4.22229 9.17513C4.22229 7.0918 4.89243 5.43208 6.23271 4.19596C7.57299 2.95985 9.12507 2.3418 10.889 2.3418C12.6528 2.3418 14.2049 2.95985 15.5452 4.19596C16.8855 5.43208 17.5556 7.0918 17.5556 9.17513C17.5556 10.564 17.0035 12.0744 15.8994 13.7064C14.7952 15.3383 13.1251 17.1057 10.889 19.0085Z",
    fill: "#676F83"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon_location.879c190b2f25d3f5b7032b0bd45c3d5c.svg";
export { ForwardRef as ReactComponent };